import { c as _c } from "react/compiler-runtime";
interface BooleanInputProps {
  label: string;
  description?: string;
  headerRight?: React.ReactNode;
  value: boolean | null;
  onChange: (value: boolean) => void;
}
export default function BooleanInput(t0) {
  const $ = _c(18);
  const {
    label,
    description,
    headerRight,
    value,
    onChange
  } = t0;
  const isUnset = value === null || value === undefined;
  let t1;
  if ($[0] !== description || $[1] !== headerRight || $[2] !== label) {
    t1 = (label || description) && <div className="flex-1">{label && <div className="flex items-center gap-2"><label className="field-label block">{label}</label>{headerRight}</div>}{description && <p className="text-ds-text-subtle dark:text-ds-text-disabled mt-1 text-xs">{description}</p>}</div>;
    $[0] = description;
    $[1] = headerRight;
    $[2] = label;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = isUnset ? "mixed" : value;
  let t3;
  if ($[4] !== isUnset || $[5] !== onChange || $[6] !== value) {
    t3 = () => onChange(isUnset ? true : !value);
    $[4] = isUnset;
    $[5] = onChange;
    $[6] = value;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = `relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-zinc-900 ${isUnset ? "bg-ds-neutral-200 dark:bg-ds-neutral-800" : value ? "bg-blue-600" : "bg-ds-neutral-300 dark:bg-ds-neutral-700"}`;
  const t5 = `inline-block h-4 w-4 transform rounded-full transition-transform ${isUnset ? "translate-x-[0.65rem] bg-zinc-400 dark:bg-zinc-500" : value ? "translate-x-6 bg-white" : "translate-x-1 bg-white"}`;
  let t6;
  if ($[8] !== t5) {
    t6 = <span className={t5} />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t6) {
    t7 = <button type="button" role="switch" aria-checked={t2} onClick={t3} className={t4}>{t6}</button>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t1 || $[16] !== t7) {
    t8 = <div className="space-y-2"><div className="flex items-center justify-between">{t1}{t7}</div></div>;
    $[15] = t1;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}